export default "__VITE_ASSET___xY2_TyC__"